import { Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { CountryISO, SearchCountryField } from 'ngx-intl-tel-input';
import * as QRCode from 'qrcode';
import { default as olarconfig } from '../../assets/olarconfig.json';
import { EcomNetworkUtils } from '../ecom-base-entities/ecom-shared/ecom-networkutils.service';
import { getPaymentId, OrderDetails } from '../ecom-models/order-details';
import { EComService } from '../ecom-services/ecom-common.service';
import { EcomSettingService } from '../ecom-services/ecom-setting.service';
import { EcomValidator } from '../ecom-services/ecom-validation';
import { EComWebStorage } from '../ecom-services/ecom-webstorage.services';
import { base64decodedString, FPX_PRODUCTION, FPX_STAGING, GiftcardService } from './ecom-giftcard.service';
import { finalize, first, takeUntil, tap } from 'rxjs/operators';
import { Subject } from 'rxjs';
interface GiftCardTheme {
  id: number;
  name: string;
  thumbUrl: string;
  imageUrl: string;
}

interface GiftCardConfig {
  expiry: number;
  type: string;
  id: number;
  name: string;

  createdAt: string;
  validityText: string;
  validityMonths: number;
  minAmount: number;
  maxAmount: number;
  multiples_of: number;
}

interface PaymentSubMethod {
  value: string;
  text: string;
  selected?: boolean;
  description?: string;
  subDescription?: string;
}

interface PaymentMethod {
  type: string;
  collapsed: boolean;
  name: string;
  selected: string;
  list: PaymentSubMethod[];
  showicon: boolean;
  option_selected: boolean;
}

@Component({
  selector: 'app-ecom-gift-card',
  templateUrl: './ecom-gift-card.component.html',
  styleUrls: ['./ecom-gift-card.component.scss']
})
export class GiftCardComponent implements OnInit, OnDestroy {
  @Input() visible = false;
  @Output() closeGiftCard = new EventEmitter<boolean>();

  @Input() customClass: string = '';
  environment: string;
  rhPaymentForm: FormGroup;
  customerDetailsForm: FormGroup;
  inquiryMessage: string;
  showMessageAfter1Min: boolean;
  qrImageSrc: any;
  requestId: any;
  qrDuitNowData: any;
  isLoading: boolean;
  interval: any;
  displayTime: string;
  inquiryCount: any;
  private cancel$ = new Subject<void>();

  pollingActive: boolean;
  bankResult: any;
  paymentResponse: any;
  paymentDone: boolean;
  modalQrPaymentRef: BsModalRef;
  @ViewChild('qrPayment', { static: true }) qrPayment: ElementRef;
  company_id: string;
  locationInfo: { location_pkid: number; register_pkid: number; company_pkid: number };
  selectedFloat: any;
  testingDuitNow = false;
  userPkid: number | null = null;

  close() {
    this.visible = false;
    this.closeGiftCard.emit(this.visible);
  }
  form: FormGroup;
  step = 1;
  isPaying = false;
  themes: GiftCardTheme[] = [];

  giftCardsFromApi: GiftCardConfig[] = [];

  activeGiftCards: GiftCardConfig[] = [];
  selectedGiftCard: GiftCardConfig;
  selectedTheme: GiftCardTheme | null = null;
  amountOptions: number[] = [];

  previewExpiryDate = '';
  purchasedDate = '';
  cardName = 'Gift Cards X-Mas';

  giftcards: any[] = [];

  defaultPaymentTypes: PaymentMethod[] = [];

  @ViewChild('customerDetails', { static: true }) customerDetails: ElementRef;
  configCustomerDetails = {
    ignoreBackdropClick: true,
    keyboard: false,
    animated: true,
    class: 'modal-dialog-centered modal-sm'
  };
  customerDetailsModalRef: BsModalRef;

  separateDialCode = true;
  SearchCountryField = SearchCountryField;
  selectedCountryISO: any = CountryISO.Malaysia;
  preferredCountries: CountryISO[] = [CountryISO.Malaysia, CountryISO.Australia, CountryISO.India, CountryISO.Singapore, CountryISO.Indonesia, CountryISO.Thailand];


  readonly countdownKey = 'countdown_end_time';
  readonly countdownDuration = 3 * 60 * 1000; // 3 mins in ms

  modalRef: BsModalRef;

  @ViewChild('paymentfailure', { static: true }) paymentfailure: ElementRef;

  showBackButton = false;
  transaction_reference: string = null;
  constructor(private formBuilder: FormBuilder, public giftcardService: GiftcardService,
    private activatedRoute: ActivatedRoute, public ecomservice: EComService,
    private modalService: BsModalService, public webstorage: EComWebStorage,
    public router: Router, private settingService: EcomSettingService,
  ) {
    this.environment = olarconfig.Environment;
    this.form = this.formBuilder.group({
      giftCardId: [null, Validators.required],
      amount: [null, Validators.required],
      email: ['', [Validators.required, Validators.email]]
    });

    this.customerDetailsForm = this.formBuilder.group({
      name: ['', Validators.compose([Validators.required, Validators.pattern(/[\S]/g)])],
      email: ['', Validators.compose([Validators.required, EcomValidator.emailValidator, Validators.pattern(/[\S]/g)])],
      contact: ['', Validators.compose([Validators.required, Validators.pattern(/[\S]/g)])]
    });

    this.rhPaymentForm = this.formBuilder.group({
      Revpay_Merchant_ID: [],
      Payment_ID: [],
      Bank_Code: [],
      Reference_Number: [],
      Amount: [],
      Currency: [],
      Transaction_Description: [],
      Customer_Name: [],
      Customer_Email: [],
      Customer_Contact: [],
      Customer_IP: [],
      Installment_Plan: [],
      Installment_Term: [],
      Key_Index: [],
      Signature: [],
      Return_URL: [],
      Promo_Code: [],
      Customization: [],
      Backend_URL: []
    });

    this.defaultPaymentTypes = [
      {
        type: 'fpx',
        collapsed: true,
        name: '',
        selected: '',
        list: this.environment === "Production" ? FPX_PRODUCTION : FPX_STAGING,
        showicon: true,
        option_selected: false
      },
      {
        type: 'ewallets',
        collapsed: true,
        name: 'e-Wallets',
        selected: '',
        list: [
          {
            value: 'Touch_n_Go', text: 'TNG', selected: false,
            description: "easier if you have TNG app"
          },
          { value: 'Grab_Pay', text: 'GrabPay', selected: false },
          {
            value: 'Maybank_QR', text: 'MAE ', selected: false,
            description: "when you receive QR code, take screenshot and save to your gallery. Go to MEA app, press scan and then press,",
            subDescription: '"<strong>scan QR code from gallery</strong>"'
          },
          { value: 'Axiata_Boost', text: 'Boost', selected: false },
          { value: 'Alipay_Online', text: 'Alipay Online', selected: false }
        ],
        showicon: true,
        option_selected: false
      },
      {
        type: 'card',
        collapsed: true,
        name: 'Credit/Debit Card',
        selected: '',
        list: [],
        showicon: false,
        option_selected: false
      },
      // {
      //   type: 'DuitNow',
      //   collapsed: true,
      //   name: 'Duit Now',
      //   selected: '',
      //   list: [],
      //   showicon: false,
      //   option_selected: false
      // }
    ];
  }

  async ngOnInit() {
    document.addEventListener('visibilitychange', this.visibilityHandler);
    await this.getIP();

    if (this.webstorage.localSt_user_order_giftcard) {
      this.step = 3;
      const localData = this.webstorage.localSt_user_order_giftcard;
      console.log('localData', localData);
      this.company_id = localData.company_id;
      this.transaction_reference = localData.order_reference.ReferenceNumber;
      this.form.patchValue({
        giftCardId: localData.giftcard.giftcard_pkid,
        amount: localData.order_reference.Amount,
        email: localData.email
      });


      if (localData.type.toLocaleLowerCase() === "duitnow") {
        this.inquiryMessage = "";
        let endTime = localStorage.getItem(this.countdownKey);
        if (!endTime) {
          const newEndTime = Date.now() + 1 * 60 * 1000; // 3 mins
          localStorage.setItem('countdown_end_time', newEndTime.toString());
          endTime = newEndTime.toString();
        }
        if (endTime) {
          this.showMessageAfter1Min = true;
          this.startCountdown(parseInt(endTime));
          this.qrImageSrc = localData.Qr_Code;
          this.modalQrPaymentRef = this.modalService.show(this.qrPayment, {
            animated: true,
            class: 'modal-dialog-centered modal-sm modal-loyalty-payment',
            ignoreBackdropClick: true,
            keyboard: false
          });
          this.requestId = localData.referenceNumber;
          this.qrDuitNowData = localData.qrDuitNowData;
          await this.startPollingInquiry();
        } else {
          localStorage.removeItem(this.countdownKey);
        }

      }
      else {
        this.isLoading = true;

        this.modalRef = this.modalService.show(this.paymentfailure, {
          animated: true,
          class: 'modal-dialog-centered modal-sm modal-loyalty-payment',
          ignoreBackdropClick: true,
          keyboard: false
        });

        const response = await this.giftcardService.checkGiftcardStatus({ ...localData.order_reference }).toPromise();
        this.isLoading = false;
        const orderRes = response.listValue;
        if (response && orderRes) {
          this.paymentResponse = "Payment is unsuccessful.";
          if (orderRes.status === "SUCCESS") {
            this.paymentResponse = orderRes.description;
            this.webstorage.localSt_user_order_giftcard = null;
            this.router.navigate(['giftcard/result'], { queryParams: { c: response.listValue.companyId, id: response.listValue.sogc_pkid } });
            this.paymentDone = true;
            setTimeout(() => {
              this.modalRef.hide();
            }, 300);
            return;
          }

        }
      }
    }

    await this.loadGiftcards();

  }

  private visibilityHandler = async () => {

    if (document.visibilityState === 'visible') {
      console.log('User back to page.');

      const localData = this.webstorage.localSt_user_order_giftcard;
      if (localData && localData.type === "DuitNow" && !this.isLoading) {
        await this.startPollingInquiry();
      }

    }
  };

  ngOnDestroy(): void {
    if (this.interval) {
      clearInterval(this.interval);
    }
    document.removeEventListener('visibilitychange', this.visibilityHandler);
  }
  startCountdown(endTime: number): void {
    this.updateDisplay(endTime);
    this.interval = setInterval(() => {
      this.updateDisplay(endTime);
    }, 1000);
  }

  updateDisplay(endTime: number): void {
    const now = Date.now();
    const diff = Math.max(0, Math.floor((endTime - now) / 1000)); // seconds remaining

    if (diff <= 0) {
      this.displayTime = '00:00';
      clearInterval(this.interval);
      localStorage.removeItem(this.countdownKey);
      return;
    }

    const minutes = Math.floor(diff / 60);
    const seconds = diff % 60;
    this.displayTime = `${this.pad(minutes)}:${this.pad(seconds)}`;
  }
  pad(num: number): string {
    return num < 10 ? '0' + num : num.toString();
  }
  async startPollingInquiry(): Promise<void> {
    this.inquiryMessage = "";
    this.pollingActive = true;
    this.bankResult = "";

    const endTime = localStorage.getItem(this.countdownKey);
    this.inquiryCount = 0;
    while (this.pollingActive) {
      if (this.inquiryCount === 0) {
        this.inquiryMessage = "Please wait and stay on this page, while we complete processing your payment​";
      } else {
        this.inquiryMessage = "We are still waiting response from Bank and will be very soon now";
      }
      if (!this.isLoading) {
        const res = await this.inquiryQr();
        if (res) {
          const orderRes = res.listValue;
          if (res.isSuccess && res.listValue && res.listValue.status === "SUCCESS") {

            this.pollingActive = false;
            this.paymentResponse = orderRes.description;
            this.webstorage.localSt_user_order_giftcard = null;
            this.paymentDone = true;
            await this.delay(2000);
            this.onPaymentCloseClick();


            this.webstorage.localSt_user_order_giftcard = null;
            this.router.navigate(['giftcard/result'], { queryParams: { c: res.listValue.companyId, id: res.listValue.sogc_pkid } });
            break;
          }
          if (!res.isSuccess) {
            // "Expired QR Code"
            if (orderRes && orderRes.status === "70") {
              this.bankResult = orderRes.message;
              this.inquiryMessage = "Sorry your payment was unsuccessful";
              this.displayTime = '00:00';
              localStorage.removeItem(this.countdownKey);
              this.stopPolling();
              clearInterval(this.interval);
              break;
            }
          }
        }

      }
      else {
        console.log(`Waiting for response from Bank, skipping duplicate call.`);
      }
      console.log(`Retrying in 5 seconds...`);
      // Waiting for 5 seconds
      this.inquiryCount++;
      await this.delay(5000);
    }

    // if (!this.isPaymentSuccessLast) {
    //   this.onTimeout(); // xử lý nếu hết 3 phút mà chưa thanh toán
    // }
  }

  onPaymentCloseClick() {
    this.webstorage.localSt_user_order_giftcard = null;
    clearInterval(this.interval);
    if (this.modalRef) this.modalRef.hide();
    if (this.modalQrPaymentRef) this.modalQrPaymentRef.hide();

    this.stopPolling();
    this.cancel$.next();

  }



  private delay(ms: number): Promise<void> {
    return new Promise(resolve => setTimeout(resolve, ms));
  }
  stopPolling(): void {
    this.pollingActive = false;
  }

  async inquiryQr2() {
    //this.isManual = true;
    if (this.isLoading) return;
    this.showMessageAfter1Min = true;
    const data = this.qrDuitNowData;
    const model = {
      amount: data.Amount,
      currency: data.Currency,
      device_id: data.Device_Id,
      entry_mode: data.Entry_Mode,
      merchant_id: data.Merchant_Id,
      original_transaction_reference_number: data.Transaction_Reference_Number,
      qr_code: data.Qr_Code,
      request_id: this.requestId,
      scheme: "DN",
      transaction_datetime: data.Transaction_Datetime
    }

    this.isLoading = true;
    const res = await this.ecomservice.httpPost(EcomNetworkUtils.GIFTCARD_INQUIRY_QR, model, '', true, true).toPromise();
    this.isLoading = false;
    this.ecomservice.commonLoading.show = false;
    this.ecomservice.loadingPage.loading = false;
    //this.isManual = false;
    return res;
    // if (res) {
    //   const orderRes = res.listValue;
    //   if (res.isSuccess && res.listValue.status === "SUCCESS") {

    //     this.pollingActive = false;
    //     this.paymentResponse = orderRes.description;
    //     this.webstorage.localSt_user_order_giftcard = null;
    //     this.paymentDone = true;
    //     await this.delay(2000);
    //     //this.onPaymentCloseClick();
    //     if (res.listValue.companyId && res.listValue.oodcdr_pkid) {
    //       // this.saveUrl(res.listValue.companyId, res.listValue.oodcdr_pkid);
    //     }
    //     alert(`Payment successful!\nYour ticket number is: ${res.listValue.order_number}`);
    //     //this.router.navigate(['status-dinein'], { queryParams: { companyId: res.listValue.companyId, serviceId: res.listValue.oodcdr_pkid } });

    //   }
    //   if (!res.isSuccess) {
    //     // "Expired QR Code"
    //     if (orderRes.status === "70") {
    //       this.bankResult = orderRes.message;
    //       this.inquiryMessage = "Sorry your payment was unsuccessful";
    //       this.displayTime = '00:00';
    //       localStorage.removeItem(this.countdownKey);
    //       this.stopPolling();
    //       clearInterval(this.interval);
    //     }
    //   }
    // }

  }

  async inquiryQr() {
    const d = this.qrDuitNowData;
    const model = {
      amount: d.Amount,
      currency: d.Currency,
      device_id: d.Device_Id,
      entry_mode: d.Entry_Mode,
      merchant_id: d.Merchant_Id,
      original_transaction_reference_number: d.Transaction_Reference_Number,
      qr_code: d.Qr_Code,
      request_id: this.requestId,
      scheme: 'DN',
      transaction_datetime: d.Transaction_Datetime
    };

    this.isLoading = true;
    try {
      const res = await this.ecomservice.httpPost(
        EcomNetworkUtils.GIFTCARD_INQUIRY_QR,
        model, '', false, false
      ).pipe(
        tap(() => console.log('[inquiryQr] firing request...')),
        takeUntil(this.cancel$),
        first(),
        finalize(() => this.isLoading = false)
      ).toPromise();
      return res;
    } catch (err) {

      console.log('[inquiryQr] error/canceled:', err);
      return null;
    } finally {
      // reset
      this.isLoading = false;
    }
  }

  onPaymentExpand(paymentType: PaymentMethod, index: number, collapsed: boolean) {

    if (paymentType.type === 'card') {
      this.defaultPaymentTypes.forEach(element => {
        element.selected = '';
        element.option_selected = false;
        element.list.forEach(ptype => {
          ptype.selected = false;
        });

        element.collapsed = true;
      });
      this.defaultPaymentTypes[index].selected = 'card';
      this.defaultPaymentTypes[index].option_selected = true;
    } else if (paymentType.type === 'loyalty') {



      this.defaultPaymentTypes.forEach(element => {
        element.selected = '';
        element.option_selected = false;
        element.list.forEach(ptype => {
          ptype.selected = false;
        });

        element.collapsed = true;
      });
      this.defaultPaymentTypes[index].selected = 'loyalty';
      this.defaultPaymentTypes[index].option_selected = true;

    } else if (paymentType.type === 'DuitNow') {

      this.defaultPaymentTypes.forEach(element => {
        element.selected = '';
        element.option_selected = false;
        element.list.forEach(ptype => {
          ptype.selected = false;
        });

        element.collapsed = true;
      });
      this.defaultPaymentTypes[index].selected = 'DuitNow';
      this.defaultPaymentTypes[index].option_selected = true;

    }

    else {
      this.defaultPaymentTypes[index].collapsed = !collapsed;
    }

    //let paymentIdDetails = this.getPaymentIdByType();
    //console.log(paymentIdDetails);
  }

  onPaymentTypeSelect(event, ptype, option, ptypeIndex, optionIndex) {
    this.defaultPaymentTypes[ptypeIndex].collapsed = true;
    this.defaultPaymentTypes.forEach(element => {
      element.selected = '';
      element.option_selected = false;

      element.list.forEach(type => {
        type.selected = false;
      });
    });
    if (event.target.checked) {
      this.defaultPaymentTypes[ptypeIndex].selected = option['text'];
      this.defaultPaymentTypes[ptypeIndex].option_selected = true;

      this.defaultPaymentTypes[ptypeIndex].list[optionIndex].selected = true;

    } else {
      this.defaultPaymentTypes[ptypeIndex].selected = '';
    }

    const paymentIdDetails = this.getPaymentIdByType();
    //console.log(paymentIdDetails);
  }
  getPaymentIdByType(): any {
    let paymentid = 0;
    let bankcode = '';

    const selectedPayment = this.defaultPaymentTypes.find(x => x.option_selected);
    if (!selectedPayment) return;

    const type = selectedPayment.type;
    if (type === 'card') {
      paymentid = getPaymentId('Visa_MasterCard');
    } else if (type === 'loyalty') {
      paymentid = getPaymentId('Loyalty');
    } else if (type === 'DuitNow') {
      paymentid = getPaymentId('DuitNow');
    }
    else if (type === 'fpx') {
      paymentid = getPaymentId('FPX_PERSONAL_ACCOUNT');
      paymentid = getPaymentId('FPX_PERSONAL_ACCOUNT');
      let fpxselected = selectedPayment.list.find(x => x.selected);
      bankcode = fpxselected.value;
    } else if (type === 'ewallets') {

      let walletselected = selectedPayment.list.find(x => x.selected);
      paymentid = getPaymentId(walletselected.value);

    }
    return {
      paymentId: paymentid,
      bankCode: bankcode,
      type
    };
  }


  async loadGiftcards() {

    this.activatedRoute.queryParams.subscribe(async params => {
      this.showBackButton = params['from'] === 'qr';
      const company_id = base64decodedString(params['c']);
      this.testingDuitNow = params['t'] === '1' ? true : false;

      this.company_id = company_id;

      if (params['u']) {
        const customerPkid = base64decodedString(params['u']);

        if (customerPkid) {
          const numValue = Number(customerPkid);
          this.userPkid = isNaN(numValue) ? null : numValue;
        }
      }


      await this.closePreviousDayOpenedFloat();
      await this.loadFloatCode();

      const res = await this.giftcardService
        .fetchGiftcards({ companyId: company_id })
        .toPromise();

      if (res.isSuccess && res.listValue) {

        this.activeGiftCards = res.listValue.giftcards.map(x => ({
          id: x.pkid,
          name: x.name,
          expiry: x.expiry,
          type: x.type,
          validityText: this.getValidityText(x.type, x.expiry),
          validityMonths: 1,
          minAmount: x.min_value,
          maxAmount: x.max_value,
          multiples_of: x.multiples_of
        }));

        this.setDefaultGiftCard();

        this.themes = res.listValue.graphics.map(x => ({
          id: x.id,
          name: x.id,
          thumbUrl: x.value,
          imageUrl: x.value
        }
        ));
        this.selectedTheme = this.themes.length ? this.themes[0] : null;
      }

    });

  }

  async loadFloatCode() {
    const model = {
      location_has_shift: false,
      opening_datetime: this.ecomservice.convertToServerTimezone(new Date()),
      recouncilation: "LOCA",
      loc_pkid: this.locationInfo.location_pkid,
      reg_pkid: this.locationInfo.register_pkid,
      device_id: this.webstorage.localSt_ip
    }
    // check status if OPEN THEN CLOSE


    const res = await this.giftcardService.checkOpenFloatShift({
      floatmodel: model,
      companyId: this.company_id,
      company_pkid: this.locationInfo.company_pkid
    }).toPromise();

    if (res.isSuccess && res.listValue && res.msg === "OPEN_DONE") {
      this.selectedFloat = res.listValue;
      return;
    }

    const data = res.listValue as any;
    const model2 = {
      opening_transaction_id: this.getNow(),
      opening_float_amount: 0,
      opening_float_notes: null,
      opening_float_reason_pkid: 0,
      opening_float_reason_name: "OPEN FLOAT",
      opening_float_authorised_by: 1,
      opening_float_created_by: 1,
      shift_pkid: 0,
      location_has_shift: data.location_has_shift,
      apk_version: null,
      type: "B",
      opening_datetime: this.ecomservice.convertToServerTimezone(new Date()),
      recouncilation: "LOCA",
      loc_pkid: this.locationInfo.location_pkid,
      reg_pkid: this.locationInfo.register_pkid,
      device_id: ""
    }

    // NOT OPEN YET => call 2nd api
    const res2 = await this.giftcardService.saveOpenFloatShift({
      floatmodel: model2,
      companyId: this.company_id,
      company_pkid: this.locationInfo.company_pkid
    }).toPromise();

    if (res2.isSuccess && res2.listValue) {
      this.selectedFloat = res2.listValue;

    }


  }

  async getIP() {
    if (this.webstorage.localSt_ip) return;

    const response = await this.ecomservice.httpGetOuterResponseHeader(EcomNetworkUtils.GET_IP_ADDRESS + this.ecomservice.GetOlarConfigValue('ipgeolocation_key'), '', false).toPromise();
    if (response.status === 200) {

      this.ecomservice.loadingPage.loading = false;
      this.webstorage.localSt_ip = response.body.ip;
      this.webstorage.localSt_latlng = response.body.latitude + ',' + response.body.longitude;
      this.webstorage.localSt_countrycode = response.body.country_code2;

    }
  }
  getNow() {
    const d = new Date();

    const yyyy = d.getFullYear();
    const MM = String(d.getMonth() + 1).padStart(2, '0');
    const dd = String(d.getDate()).padStart(2, '0');
    const HH = String(d.getHours()).padStart(2, '0');
    const mm = String(d.getMinutes()).padStart(2, '0');
    const ss = String(d.getSeconds()).padStart(2, '0');

    return `${yyyy}${MM}${dd}${HH}${mm}${ss}`;
  }

  async closePreviousDayOpenedFloat() {

    const res = await this.giftcardService
      .closePreviousDayOpenedFloat({ companyId: this.company_id })
      .toPromise();

    if (res.isSuccess && res.listValue) {
      const data = res.listValue;
      this.locationInfo = {
        location_pkid: data.store_pkid,
        register_pkid: data.store_register_pkid,
        company_pkid: data.store_register_company_pkid
      }
    }


  }

  getValidityText(type: string, expiry: number) {
    switch (type) {
      case 'DA':
        return `${expiry} day(s)`
      case 'MO':
        return `${expiry} month(s)`
      default:
        return `${expiry} year(s)`
    }
  }
  setDefaultGiftCard(): void {
    if (!this.activeGiftCards.length) return;

    const defaultGiftCard = this.activeGiftCards[0];
    this.selectedGiftCard = defaultGiftCard;

    this.form.patchValue({
      giftCardId: defaultGiftCard.id
    });

    this.buildAmountOptions(this.selectedGiftCard.minAmount, this.selectedGiftCard.maxAmount, this.selectedGiftCard.multiples_of)

    if (this.amountOptions.length) {
      this.form.patchValue({
        amount: this.amountOptions[0]
      });
    }

    this.updatePreviewDates();
  }

  onGiftCardChange() {
    const id = +this.form.get('giftCardId').value;
    this.selectedGiftCard = this.activeGiftCards.find(x => x.id === id) || null;

    if (this.selectedGiftCard) {

      this.buildAmountOptions(this.selectedGiftCard.minAmount, this.selectedGiftCard.maxAmount, this.selectedGiftCard.multiples_of);
      //buildGiftCardAmounts
      //this.buildAmountOptions(this.selectedGiftCard);
      this.form.patchValue({
        amount: this.amountOptions.length ? this.amountOptions[0] : null
      });
    }

    this.updatePreviewDates();
  }
  selectTheme(theme: GiftCardTheme): void {
    this.selectedTheme = theme;
  }

  goToReview(): void {
    if (this.form.invalid || !this.selectedGiftCard || !this.selectedTheme) {
      this.form.markAllAsTouched();
      return;
    }

    this.updatePreviewDates();
    this.step = 2;
    setTimeout(() => this.scrollTop());
  }

  scrollTop(): void {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  backToForm(): void {
    this.step = 1;
  }

  proceedToPay() {
    this.step = 3;
    setTimeout(() => this.scrollTop());
  }

  async checkPayment() {
    const paymentType = this.defaultPaymentTypes.find(x => x.option_selected);

    // console.log(paymentType);
    // console.log(111, this.getPaymentIdByType())

    if (!paymentType) return;

    if (paymentType.type === 'fpx') {
      this.customerDetailsForm.reset();
      //paymenttype = 'FPX_PERSONAL_ACCOUNT';

      this.customerDetailsModalRef = this.modalService.show(this.customerDetails, this.configCustomerDetails);
      return;
    }

    await this.pay();
  }

  onCustomerDetailCloseClick() {
    this.customerDetailsModalRef.hide();
  }

  async onCustomerNextClick() {

    if (this.customerDetailsForm.invalid) {
      Object.keys(this.customerDetailsForm.controls).forEach(key => {
        this.customerDetailsForm.get(key).markAsDirty();
      });
      return;
    }

    const formData = this.customerDetailsForm.getRawValue();
    let number = formData.contact.number;
    const countryCode = formData.contact.countryCode;
    number = number.replace('-', '').replace(' ', '');
    const dialCode = formData.contact.dialCode;
    const dialWithoutCode = dialCode.replace(/\D/g, '');

    this.rhPaymentForm.patchValue({

      Customer_Name: formData.name,
      Customer_Email: formData.email,
      Customer_Contact: `${dialWithoutCode}${number}`,
    });

    await this.pay();

  }


  async pay() {

    const loggedInUser = this.settingService.getUserInfo();
    if (loggedInUser) {
      this.userPkid = loggedInUser.userPkid;
    }

    if (this.isPaying) return;

    this.isPaying = true;

    const giftcard = {
      giftcard_pkid: this.form.value.giftCardId,
      giftcard_name: this.selectedGiftCard.name,
      giftcard_number: null,
      giftcard_price: this.form.value.amount,
      giftcard_pin: null,
      giftcard_total_discount: 0,
      giftcard_has_pos_discount: true,
      giftcard_graphics: this.selectedTheme.id
    }

    const selectedPayment = this.getPaymentIdByType();
    const payment = {
      payment_type_pkid: selectedPayment.paymentId,
      payment_type_card_ewallet: 3,
      payment_type_name: "Cash",
      paid_amount: this.form.value.amount,
      payment_type: selectedPayment.type,
      payment_datetime: new Date()
    }

    const model = {
      giftcard,
      payment,
      type: this.selectedGiftCard.type,
      expiry: this.selectedGiftCard.expiry,
      location_pkid: this.locationInfo.location_pkid,
      register_pkid: this.locationInfo.register_pkid,
      email: this.form.value.email,
      company_id: this.company_id,
      company_pkid: this.locationInfo.company_pkid,
      transaction_reference: this.transaction_reference,
      open_close_code: this.selectedFloat ? this.selectedFloat.open_close_code : null,
      open_close_pkid: this.selectedFloat ? this.selectedFloat.open_close_pkid : null,
      customer_pkid: this.userPkid
    }

    console.log('payment payload', model);

    const res = await this.giftcardService
      .createGiftcardPayment(model)
      .toPromise();

    this.isPaying = false;

    if (res.isSuccess && res.value) {

      const amount = Number(this.form.value.amount);
      const formattedAmount = isNaN(amount) ? '0.00' : amount.toFixed(2);

      const referenceNumber = res.value;

      const order_reference = {
        Key: this.ecomservice.GetOlarConfigValue('rhPayments_merchant_key_key_index1'),
        MerchantId: this.ecomservice.GetOlarConfigValue('rhPayments_merchant_id'),
        ReferenceNumber: referenceNumber,
        Amount: formattedAmount,
        Currency: 'MYR'
      };

      const localData = {
        type: selectedPayment.type,
        order_reference: order_reference,
        giftcard
        // user_info: user_info
      };

      this.webstorage.localSt_user_order_giftcard = localData;

      if (selectedPayment.type.toLocaleLowerCase() === 'duitnow') {

        this.getQRPayment(referenceNumber, localData);
      }
      else {
        let paymentDetails = this.getPaymentIdByType();
        const order = new OrderDetails({
          PaymentType: paymentDetails.bankCode,
          Reference_Number: res.value,
          Amount: formattedAmount,
          Currency: "MYR",
          Transaction_Description: "GIFTCARD",
          Customer_Name: null,
          Customer_Email: this.form.value.email,
          Customer_Contact: null,
          Customer_IP: this.webstorage.localSt_ip
        });

        this.sendPaymentRequest(order);
      }


    }

    console.log(res);

    // // TODO: Replace by real payment API
    // setTimeout(() => {
    //   this.isPaying = false;
    //   this.purchasedDate = this.formatDate(new Date());
    //   this.step = 3;
    // }, 1200);
  }


  async getQRPayment(referenceNumber: string, localData) {
    const amount = Number(this.form.value.amount);
    const formattedAmount = isNaN(amount) ? '0.00' : amount.toFixed(2);
    this.qrImageSrc = "";
    this.modalQrPaymentRef = this.modalService.show(this.qrPayment, {
      animated: true,
      class: 'modal-dialog-centered modal-sm modal-loyalty-payment',
      ignoreBackdropClick: true,
      keyboard: false
    });
    const model = {
      request_id: referenceNumber,
      amount: formattedAmount
    }
    this.requestId = referenceNumber;
    const response = await this.ecomservice.httpPost(EcomNetworkUtils.POST_ORDER_QR_PAYMENT, model, '', false, false).toPromise();
    this.ecomservice.commonLoading.show = false;
    this.ecomservice.loadingPage.loading = false;
    if (response.isSuccess && response.listValue) {
      this.qrDuitNowData = response.listValue;
      if (!response.listValue.Qr_Code) return;
      
      QRCode.toDataURL(response.listValue.Qr_Code, { errorCorrectionLevel: 'M', width: 220 })
        .then(url => {
          this.qrImageSrc = url;
          if (!this.qrImageSrc) {
            return;
          }
          // Get QR starts countdown
          //const newEndTime = Date.now() + 3 * 1000;
          const newEndTime = Date.now() + 3 * 60 * 1000; // 3 mins
          localStorage.setItem('countdown_end_time', newEndTime.toString());
          localData.Qr_Code = url;
          localData.referenceNumber = referenceNumber;
          localData.qrDuitNowData = this.qrDuitNowData;
          this.webstorage.localSt_user_order_giftcard = localData;

          setTimeout(() => {
            this.showMessageAfter1Min = true;
          }, 60000);
          this.startCountdown(newEndTime);
          this.startPollingInquiry();
        }).catch(console.error);


    }
  }


  sendPaymentRequest(request: OrderDetails) {
    //signature for request as per doc
    // Signature Value = "Merchant Key" + "Revpay Merchant ID" + "Reference Number" + "Amount" + "Currency" 
    const merchantKey = this.ecomservice.GetOlarConfigValue('rhPayments_merchant_key_key_index1');
    const merchantId = this.ecomservice.GetOlarConfigValue('rhPayments_merchant_id'); //olarconfig.rhPayments.merchant_id;
    const referenceNumber = request.Reference_Number;
    const signatureValue = merchantKey + merchantId + referenceNumber + request.Amount + request.Currency;
    const signature = this.ecomservice.generateSHA512Hash(signatureValue);

    let paymentDetails = this.getPaymentIdByType();
    const input = {
      Revpay_Merchant_ID: merchantId,
      Payment_ID: paymentDetails.paymentId,
      Bank_Code: "TEST0021",
      Reference_Number: request.Reference_Number,
      Amount: request.Amount,
      Currency: request.Currency,
      Transaction_Description: request.Transaction_Description,
      Customer_Name: request.Customer_Name,
      Customer_Email: request.Customer_Email,
      Customer_Contact: request.Customer_Contact,
      Customer_IP: request.Customer_IP,
      Installment_Plan: '',
      Installment_Term: '',
      Key_Index: 1,
      Signature: signature,
      Return_URL: this.ecomservice.GetOlarConfigValue('rhPayments_paymentfrontreturnurl'),
      Promo_Code: request.Promo_Code,
      Backend_URL: this.ecomservice.GetOlarConfigValue('rhPayments_paymentbackendurl')
    };
    this.rhPaymentForm.controls['Revpay_Merchant_ID'].setValue(input.Revpay_Merchant_ID);
    this.rhPaymentForm.controls['Payment_ID'].setValue(input.Payment_ID);
    if (input.Payment_ID == 3) {
      this.rhPaymentForm.controls['Bank_Code'].setValue(input.Bank_Code);
      let number = '';
      let countryCode = '';
      //number = this.customerDetailsForm.getRawValue().contact.nationalNumber;
      //countryCode = this.customerDetailsForm.getRawValue().contact.countryCode;
      number = number.replace('-', '').replace(' ', '');

      //input.Customer_Name = this.customerDetailsForm.getRawValue().name;
      //input.Customer_Email = this.customerDetailsForm.getRawValue().email;
      input.Customer_Contact = number;
    }

    this.rhPaymentForm.patchValue({
      Reference_Number: input.Reference_Number,
      Amount: input.Amount,
      Currency: input.Currency,
      Transaction_Description: input.Transaction_Description,
      // Customer_Name: input.Customer_Name,
      // Customer_Email: input.Customer_Email,
      // Customer_Contact: input.Customer_Contact,
      Customer_IP: "1.32.96.57",
      Customization: "{\"Displaying_Payment_Method\":[\"2\"]}",
      Installment_Plan: input.Installment_Plan,
      Installment_Term: input.Installment_Term,
      Key_Index: input.Key_Index,
      Signature: input.Signature,
      Return_URL: input.Return_URL,
      Backend_URL: input.Backend_URL
    });
    if (input.Promo_Code) {
      this.rhPaymentForm.controls['Promo_Code'].setValue(input.Promo_Code);
    }
    // don't display payment change option to user
    if (input.Payment_ID == 2) {
      let displayMethods = JSON.stringify({ Displaying_Payment_Method: ['2'] });
      this.rhPaymentForm.controls['Customization'].setValue(displayMethods);
    }
    const requestUrl = this.ecomservice.GetOlarConfigValue('rhPayments_paymentrequesturl');


    const data = this.rhPaymentForm.value;
    console.log(2, data)
    const form = document.createElement('form');
    form.method = 'POST';
    form.action = requestUrl;

    Object.keys(data).forEach(key => {
      if (data[key] !== null && data[key] !== undefined) {
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = key;
        input.value = data[key];
        form.appendChild(input);
      }
    });

    document.body.appendChild(form);
    form.submit();
  }


  done(): void {
    console.log('done');
    // TODO: redirect listing page / reset form / close modal
    this.resetFlow();
  }

  resetFlow(): void {
    this.step = 1;
    this.form.patchValue({
      email: ''
    });
    this.setDefaultGiftCard();
  }

  updatePreviewDates(): void {
    const today = new Date();
    this.previewExpiryDate = this.calculateExpiryDate(today, this.selectedGiftCard.type,
      this.selectedGiftCard.expiry);
  }

  calculateExpiryDate(baseDate: Date, type: string, expiry: number): string {
    const d = new Date(baseDate);

    switch (type) {
      case 'DA':
        // Add days
        d.setDate(d.getDate() + expiry);
        break;
      case 'MO':
        // Add months
        d.setMonth(d.getMonth() + expiry);
        break;
      case 'YE':
        // Add years
        d.setFullYear(d.getFullYear() + expiry);
        break;
      default:
        // Default to months if type is not recognized
        d.setMonth(d.getMonth() + expiry);
    }

    return this.formatDate(d);
  }

  formatDate(date: Date): string {
    const day = date.getDate();
    const month = date.getMonth() + 1;
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  }

  buildAmountOptions(min: number, max: number, multipleOf: number) {

    const result: number[] = [];

    if (this.testingDuitNow) {
      result.push(0.01);
    }

    if (!multipleOf || multipleOf <= 0) {
      return result;
    }

    let start = min;

    for (let amount = start; amount <= max; amount += multipleOf) {
      result.push(amount);
    }

    this.amountOptions = result;
  }


  onCloseClick() {
    this.modalRef.hide();
  }

  goBack() {
    if (this.webstorage.sessionSt_giftCardFromPage) {
      const url = this.webstorage.sessionSt_giftCardFromPage;
      this.webstorage.sessionSt_giftCardFromPage = null;
      window.location.href = url;
      return;
    }

  }

}


